var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("header", { staticClass: "header-title" }, [
    _c("span", { staticClass: "header-text" }, [
      _vm._v(_vm._s(_setup.props.title)),
    ]),
    _setup.props.showClose
      ? _c("span", {
          class: [_setup.closeIcon, "icon-close"],
          on: { click: _setup.close },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }